import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  studentsPath,
  clearErrorMessage,
  clearSuccessMessage,
  Context,
  createStudent,
  CREATE_STUDENT_SUCCESS_MESSAGE,
  IStudentParam,
  fetchClasses,
  fetchPlans,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import StudentForm from "../../../templates/manager/StudentForm";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();
  const { currentYear } = useCurrentYear();

  React.useEffect(() => {
    if (state.success_message === CREATE_STUDENT_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      history.push(studentsPath);
    }
  }, [history, dispatch, state.success_message]);

  const createStudentFunc = React.useCallback(
    (student: IStudentParam) => {
      sessionStorage.setItem("current_grade", `${student.current_grade}`);
      dispatch(peep(createStudent(student)));
    },
    [dispatch, peep],
  );

  React.useEffect(() => {
    dispatch(fetchClasses(currentYear));
    return () => dispatch(clearErrorMessage());
  }, [dispatch, currentYear]);

  React.useEffect(() => {
    dispatch(fetchPlans());
  }, [dispatch]);

  return (
    <div>
      <Breadcrumb
        links={[
          {
            title:
              state.manager.school?.use_case === "cram_school"
                ? titles.cramSchoolStudents
                : titles.students,
            to: studentsPath,
          },
        ]}
        currentTitle={titles.newStudent}
      />
      <StudentForm
        title={titles.newStudent}
        calling={calling}
        classes={state.classes}
        error={state.error}
        school={state.manager.school!}
        plans={state.plans}
        isNextYear={false}
        upsertStudent={createStudentFunc}
      />
    </div>
  );
};
